import React, { useEffect, useState } from "react";
import Spinner from 'react-bootstrap/Spinner';
import '../../custom.css';

export default function PRHLoader({ message = null }) {
    return (
        <div className="loader-box">
            <Spinner animation="border" size="sm" variant="primary"></Spinner> 
            <span className="loader-info">{message ?? 'One moment please...'}</span>
        </div>
    );
}


